import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import { setAcceptedAnswer, toggleReaction } from './service/communityApi';
const reactionLabels = {
  helpful: 'Полезно',
  insightful: 'Интересно',
  thanks: 'Спасибо'
};
function requestErrorMessage(error) {
  return error?.response?.errors?.[0]?.detail || error?.message || 'Не удалось сохранить изменение.';
}
function refreshAcceptedState(acceptedPostId) {
  // Обновляем уже загруженные сообщения локально, чтобы отметка решения менялась без перезагрузки потока.
  app.store.all('posts').forEach(post => {
    post.pushAttributes({
      isAcceptedAnswer: Number(post.id()) === Number(acceptedPostId)
    });
  });
}
export default function addCommunityControls() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!discussion.canAcceptAnswer()) return;
    items.add('devconnect-question', m(Button, {
      icon: 'far fa-circle-question',
      onclick: async () => {
        try {
          await discussion.save({
            isQuestion: !discussion.isQuestion()
          });
        } catch (error) {
          app.alerts.show({
            type: 'error'
          }, requestErrorMessage(error));
        }
      },
      disabled: Boolean(discussion.acceptedPostId())
    }, discussion.isQuestion() ? 'Это вопрос' : 'Отметить как вопрос'), 5);
  });
  extend(CommentPost.prototype, 'elementAttrs', function (attrs) {
    attrs.className = classList(attrs.className, {
      'Post--acceptedAnswer': this.attrs.post.isAcceptedAnswer()
    });
  });
  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    if (post.isAcceptedAnswer()) {
      items.add('devconnect-accepted', m('span', {
        className: 'dc-answer-badge'
      }, '✓ Принятый ответ'), 120);
    }
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion();
    if (discussion?.isQuestion() && discussion.canAcceptAnswer() && Number(post.number()) > 1) {
      items.add('devconnect-accept-answer', m(Button, {
        className: 'Button Button--link',
        icon: post.isAcceptedAnswer() ? 'fas fa-circle-check' : 'far fa-circle-check',
        loading: Boolean(this.dcAnswerLoading),
        onclick: async () => {
          this.dcAnswerLoading = true;
          try {
            const response = await setAcceptedAnswer(discussion.id(), post.isAcceptedAnswer() ? null : Number(post.id()));
            discussion.pushAttributes({
              isQuestion: true,
              acceptedPostId: response.data.acceptedPostId
            });
            refreshAcceptedState(response.data.acceptedPostId);
            app.alerts.show({
              type: 'success'
            }, response.data.acceptedPostId ? 'Ответ принят.' : 'Отметка решения снята.');
          } catch (error) {
            app.alerts.show({
              type: 'error'
            }, requestErrorMessage(error));
          } finally {
            this.dcAnswerLoading = false;
            m.redraw();
          }
        }
      }, post.isAcceptedAnswer() ? 'Снять решение' : 'Принять ответ'), 30);
    }
    if (!post.canReact()) return;
    const summary = post.reactionSummary() || {};
    const selected = post.currentUserReaction();
    items.add('devconnect-reactions', m('span', {
      className: 'dc-post-reactions'
    }, Object.entries(reactionLabels).map(_ref => {
      let [reaction, label] = _ref;
      return m(Button, {
        key: reaction,
        className: classList('Button Button--link dc-reaction', {
          'is-selected': selected === reaction
        }),
        disabled: Boolean(this.dcReactionLoading),
        onclick: async () => {
          this.dcReactionLoading = true;
          try {
            const response = await toggleReaction(post.id(), reaction);
            post.pushAttributes({
              currentUserReaction: response.data.selected,
              reactionSummary: response.data.summary
            });
          } catch (error) {
            app.alerts.show({
              type: 'error'
            }, requestErrorMessage(error));
          } finally {
            this.dcReactionLoading = false;
            m.redraw();
          }
        }
      }, `${label}${summary[reaction] ? ` · ${summary[reaction]}` : ''}`);
    })), 20);
  });
}